import { motion } from "framer-motion";

const EASE = [0.25, 1, 0.5, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </MotionTag>
  );
};

// Overline label
export const Overline = ({ children, className = "" }) => (
  <span
    className={`text-xs tracking-[0.28em] uppercase text-gold font-sans font-light ${className}`}
  >
    {children}
  </span>
);
